/**
 * JulgamentoContas view component.
 * @module components/Views/JulgamentoContasView
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Container } from '@plone/components';
import Estado from '../Estado/Estado';
import FileViewer from '../FileViewer/FileViewer';

/**
 * JulgamentoContas view component class.
 * @function JulgamentoContasView
 * @params {object} content Content object.
 * @returns {string} Markup of the component.
 */
const JulgamentoContasView = ({ content }) => {
  const file = content.file;
  const file_ata = content.file_ata;
  return (
    <Container
      id="page-document"
      narrow
      className="view-wrapper julgamentocontas-view"
    >
      <div className={'header-estado'}>
        <h1 className="documentFirstHeading">{content.title}</h1>
        <Estado review_state={content.status} />
      </div>
      {content.description && (
        <p className="documentDescription">{content.description}</p>
      )}
      {file && <FileViewer file={file} header={'Teor do julgamento'} />}
      {file_ata && <FileViewer file={file_ata} header={'Ata da sessão'} />}
    </Container>
  );
};

/**
 * Property types.
 * @property {Object} propTypes Property types.
 * @static
 */
JulgamentoContasView.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    file: PropTypes.shape({
      download: PropTypes.string,
      filename: PropTypes.string,
    }),
  }).isRequired,
};

export default JulgamentoContasView;
